var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarredOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1413 3.75478L14.8131 7.12604C15.041 7.59534 15.649 8.04548 16.1619 8.13168L19.1921 8.63928C21.1299 8.96491 21.5858 10.3824 20.1895 11.7807L17.8337 14.1559C17.4348 14.5581 17.2163 15.3339 17.3398 15.8894L18.0142 18.8297C18.5462 21.157 17.3208 22.0573 15.2785 20.8409L12.4383 19.1457C11.9254 18.8393 11.08 18.8393 10.5575 19.1457L7.71735 20.8409C5.68458 22.0573 4.44972 21.1474 4.98166 18.8297L5.65608 15.8894C5.77957 15.3339 5.56109 14.5581 5.16214 14.1559L2.8064 11.7807C1.41955 10.3824 1.866 8.96491 3.80379 8.63928L6.83395 8.13168C7.3374 8.04548 7.94533 7.59534 8.1733 7.12604L9.84512 3.75478C10.757 1.92549 12.2389 1.92549 13.1413 3.75478Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarredOutline);
export default __webpack_public_path__ + "static/media/starred-outline.9c1dd1aa7f96ca04b79087d64a3374b7.svg";
export { ForwardRef as ReactComponent };